import React from "react";
import json_service from "./Service.json";
import json_navbar from "../UI/Navbar/Navbar.json";

import "./Service.css";

const Service = ({ lang }) => {
  return (
    <div className="service">
      <h1>{json_navbar.service[lang]}</h1>
      {json_service.map((block, index) => (
        <React.Fragment key={index}>
          <div className="serviceTitle">{block.title[lang]}</div>
          {block.text[lang].map((paragraph, idx) => (
            <p key={idx} dangerouslySetInnerHTML={{ __html: paragraph }}></p>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Service;



// WEBPACK FOOTER //
// ./src/components/Service/Service.jsx